import PicksAnalytics from '../../components/moment/PicksAnalytics';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';
import api from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('entriesStarted', 'setEntriesStarted', 0),
  withState('columnMaterialTable', 'setColumnMaterialTable', []),
  withState('entriesCompleted', 'setEntriesCompleted', 0),
  withState('entriesCompletedPercentage', 'setEntriesCompletedPercentage', 0),
  withState('picksData', 'setPicksData', []),
  withHandlers({
    getPicksAnalytics: props => async interactionId => {
      const dataAnalytics = await api.getPicksStatistics(interactionId);
      let columnMaterialTable = [...dataAnalytics.questions];

      props.setColumnMaterialTable(columnMaterialTable);
      props.setEntriesCompleted(dataAnalytics.entriesCompleted);
      props.setEntriesStarted(dataAnalytics.entriesStarted);
      props.setEntriesCompletedPercentage(
        dataAnalytics.entriesCompletedPercentage
      );
      props.setPicksData(dataAnalytics.users);
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      if (this.props.interaction) {
        this.props.getPicksAnalytics(this.props.interaction._id);
      }
    },
  })
);

export default enhance(PicksAnalytics);
